import { SHOW_LOGOUT_MODAL, HIDE_LOGOUT_MODAL } from "../actions/types";

interface LogoutModalState {
	isVisible: boolean;
}

const initialState: LogoutModalState = {
	isVisible: false,
};

const logoutModal = (state = initialState, action: any) => {
	switch (action.type) {
		case SHOW_LOGOUT_MODAL:
			return {
				...state,
				isVisible: true,
			};
		case HIDE_LOGOUT_MODAL:
			return {
				...state,
				isVisible: false,
			};
		default:
			return state;
	}
};

export default logoutModal;
